import { Type } from '@angular/core';

export interface BlogPostMeta {
  slug: string;
  title: string;
  description: string;
  date: string;
  excerpt: string;
  loadComponent: () => Promise<Type<unknown>>;
}

/**
 * Registry of blog posts. Mirrors the `changelog-entries.ts` pattern: a static
 * array drives both the `/blog` index and, in `app.routes.ts`, the `/blog/:slug`
 * route table. `blogPostSlugs` is the form WO-6 imports for `getPrerenderParams`.
 *
 * Listed newest first.
 */
export const blogPosts: BlogPostMeta[] = [
  {
    slug: 'platform-architecture',
    title: 'How Partiri Is Built: Kubernetes, Rust and Go',
    description:
      'A look under the hood of Partiri: a Kubernetes-native PaaS built from scratch with Rust and Go services, plus a TypeScript API and dashboard.',
    date: '2026-08-04',
    excerpt:
      'No forked PaaS, no borrowed control plane. Here is how the pieces — Kubernetes, Rust, Go and TypeScript — fit together.',
    loadComponent: () =>
      import('./posts/platform-architecture/platform-architecture.component').then(
        m => m.PlatformArchitectureComponent
      )
  },
  {
    slug: 'eu-data-residency-gdpr',
    title: 'Why EU Data Residency Actually Matters for GDPR',
    description:
      'What GDPR really requires of a hosting provider, why cross-border transfers are the actual legal risk, and how EU-only infrastructure changes the calculus.',
    date: '2026-08-03',
    excerpt:
      '"GDPR-compliant" gets printed on every hosting homepage. Here is what the regulation actually asks of the infrastructure underneath your app.',
    loadComponent: () =>
      import('./posts/eu-data-residency-gdpr/eu-data-residency-gdpr.component').then(
        m => m.EuDataResidencyGdprComponent
      )
  }
];

export const blogPostSlugs: readonly string[] = blogPosts.map(post => post.slug);

export function findBlogPost(slug: string): BlogPostMeta | undefined {
  return blogPosts.find(post => post.slug === slug);
}
